/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import featuresWithDefaults from '~/featuresWithDefaults';
import axios, { auth } from './axios';

export const applyForKycLevel = (payload?: any) => {
  const id = auth.getProfile() as string;
  return axios
    .post(`/profiles/${id}/applyForKycLevel`, {
      kycLevel: featuresWithDefaults.kyc.applyForKycLevel.startKycProcess,
      payload,
    })
    .then((res) => res.data);
};
